export {
  default as warehouse,
  ReactComponent as Warehouse,
} from '@assets/icons/use-cases/warehouse.svg'    
